import React from 'react';

function Topbar({
  busqueda, setBusqueda,
  agenteLogueadoId, setAgenteLogueadoId,
  agentes,
  selectedDemoUserId, setSelectedDemoUserId, demoUsers,
  stats,
  vistaActiva, setVistaActiva,
}) {
  const agenteNombre = (() => {
    try {
      return (JSON.parse(localStorage.getItem('wc_agente') || '{}').nombre || 'U')[0];
    } catch { return 'U'; }
  })();

  return (
    <div className="topbar">
      <div className="top-left">
        <div className="status-pill">
          <span className="online-dot" />
          <span>En línea</span>
        </div>
        <div className="search-bar">
          <input
            type="text"
            placeholder="Buscar por nombre o teléfono..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
          />
        </div>
        <select
          className="topbar-select"
          value={agenteLogueadoId || ''}
          onChange={(e) => {
            const val = e.target.value || null;
            setAgenteLogueadoId(val);
            if (val) localStorage.setItem('weconnect_agente_id', val);
            else localStorage.removeItem('weconnect_agente_id');
          }}
        >
          <option value="">— Agente —</option>
          {agentes.filter((a) => a.activo !== false).map((a) => (
            <option key={a.id} value={a.id}>{a.nombre}</option>
          ))}
        </select>
        <select
          className="topbar-select"
          value={selectedDemoUserId}
          onChange={(e) => setSelectedDemoUserId(e.target.value)}
        >
          {demoUsers.map((user) => (
            <option key={user.id} value={user.id}>{user.nombre}</option>
          ))}
        </select>
      </div>
      <div className="top-right">
        <div className="top-metric">
          <span className="stat-num gradient">{stats.activas}</span>
          <span className="top-metric-label">Activas</span>
        </div>
        <div className="top-divider" />
        <div className="top-metric">
          <span className="stat-num warning">{stats.pendientes}</span>
          <span className="top-metric-label">Sin asignar</span>
        </div>
        <div className="top-divider" />
        <div className="top-metric">
          <span className="stat-num danger">{stats.criticas}</span>
          <span className="top-metric-label">Críticas</span>
        </div>
        <div className="top-divider" />
        <div className="top-metric">
          <span className="stat-num danger">{stats.derivadas}</span>
          <span className="top-metric-label">Derivadas</span>
        </div>
        <div className="top-divider" />
        <button className={`view-btn ${vistaActiva === 'activas' ? 'active' : ''}`} onClick={() => setVistaActiva('activas')}>Activas</button>
        <button className={`view-btn ${vistaActiva === 'historial' ? 'active' : ''}`} onClick={() => setVistaActiva('historial')}>Historial</button>
        <div className="agent-avatar">{agenteNombre}</div>
      </div>
    </div>
  );
}

export default React.memo(Topbar);
